module.exports = __webpack_public_path__ + "media/assets/icons/hourglass-62613c0aa7615530a15cb0d4b033bb4b.svg";